import { Injectable, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import * as globals from '@reusable/services/globals';
import { map } from 'rxjs/operators';

@Injectable()
export class CarsCustomerService {
  responseData: any;
  handleError: any;
  private toggleIt: EventEmitter<any> = new EventEmitter();
  toggleSender = this.toggleIt.asObservable();
  askToToggle(change: any) {
    this.toggleIt.next(change);
  }
  constructor(private router: Router, private httpClient: HttpClient, private gtn: globals.GetTokenNow) {}
  viewCar(carId) {
    return this.httpClient.get(`${globals.domain}/customer/cars/${carId}/view`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  editCar(carId) {
    return this.httpClient.get(`${globals.domain}/customer/cars/${carId}/edit/`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  removeCar(carId) {
    return this.httpClient.delete(`${globals.domain}/customer/cars/${carId}/remove/`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  updateCar(carId, body) {
    return this.httpClient
      .put(`${globals.domain}/customer/cars/${carId}/update/`, JSON.stringify(body), this.gtn.getHeaders())
      .pipe(map(res => res as any));
  }

  listCars(sort, records, pageNumber, queries?) {
    const headers = this.gtn.getHeaders();
    headers['params'] = queries;
    return this.httpClient
      .get(`${globals.domain}/customer/cars/list/sortBy-${sort}/${records}/${pageNumber}/`, headers)
      .pipe(map(res => res as any));
  }

  addCar(body) {
    return this.httpClient.post(`${globals.domain}/customer/cars/add/`, JSON.stringify(body), this.gtn.getHeaders()).pipe(map(res => res as any));
  }

  coreManufactures(manifcId) {
    return this.httpClient.get(`${globals.domain}/core/manufactures/${manifcId}/view/`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  coreModels(modelId) {
    return this.httpClient.get(`${globals.domain}/core/models/${modelId}/view/`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  getModels(manufactureId) {
    return this.httpClient
      .get(`${globals.domain}/core/models/list/sortBy-order/250/1/?manufactureId=${manufactureId}&isDeleted=false`, globals.cfAccessOptions())
      .pipe(map(res => res as any));
  }
  decodeCar(body) {
    const headers = this.gtn.getHeaders();
    return this.httpClient.post(`${globals.domain}/cars/decode`, body, headers).pipe(map(res => res as any));
  }
}